import { useEffect, useState } from 'react';
import ReactDOM from 'react-dom';
import { subscribeDock, getDragState, getZoneRect } from '../hooks/useDraggable';

/**
 * Mientras se arrastra una burbuja, marca la zona donde va a quedar al soltarla. Sin esto
 * el arrastre "salta" al soltar y no se entiende por qué cayó ahí.
 */
export default function DockDropHint() {
  const [drag, setDrag] = useState(null);
  useEffect(() => subscribeDock(() => setDrag(getDragState())), []);
  if (!drag) return null;
  const r = getZoneRect(drag.zone);
  return ReactDOM.createPortal(
    <div
      aria-hidden="true"
      style={{
        position: 'fixed', left: r.left + 6, top: r.top + 6,
        width: Math.max(0, r.width - 12), height: Math.max(0, r.height - 12),
        border: '2px dashed var(--c-brand)', borderRadius: 14,
        background: 'color-mix(in srgb, var(--c-brand) 8%, transparent)',
        pointerEvents: 'none', zIndex: 9980,
        transition: 'left .12s ease, top .12s ease, width .12s ease, height .12s ease',
      }}
    />,
    document.body,
  );
}
